<button mat-icon-button class="closer" (click)="cancel()">
  <mat-icon>close</mat-icon>
</button>
<h2 mat-dialog-title class="settings-title">{{ title }}</h2>

<div mat-dialog-content class="view-settings-content">

  @if (!canEdit) {
    <div class="viewer-banner">
      <mat-icon>lock</mat-icon>
      <span>Viewer access — read-only</span>
    </div>
  }

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Name</mat-label>
    <input matInput [(ngModel)]="name" (ngModelChange)="onNameChange()" maxlength="55" required [disabled]="!canEdit" autocomplete="off">
  </mat-form-field>
  @if (canEdit && nameIsDuplicate) {
    <div class="dup-warning">A view with this name already exists on this grid.</div>
  }

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Description</mat-label>
    <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="6"
              [(ngModel)]="description" maxlength="255" placeholder="Optional" [disabled]="!canEdit"
              autocomplete="off"></textarea>
  </mat-form-field>

  <div class="owner-line">
    <span class="field-label">Owner</span>
    <span class="owner-chip">
      <span class="initials-avatar sm">{{ initials(ownerName) }}</span>
      {{ ownerName }}
    </span>
  </div>

  <div class="visibility-block">
    <div class="field-label">Visibility</div>
    <mat-radio-group class="vis-options" [(ngModel)]="visibility" [disabled]="!canManage">
      @for (option of visOptions; track option) {
        <mat-radio-button [value]="option">{{ option }}</mat-radio-button>
      }
    </mat-radio-group>
  </div>

  <!-- One share block, relabeled per visibility:
       Shared = collaborators with per-person roles; Public = named editors -->
  @if (showShareBlock) {
    <div class="collab-block">
      <div class="field-label">{{ shareHeading }}
        @if (shareHint) {
          <span class="field-label-hint">{{ shareHint }}</span>
        }
      </div>
      @if (loadingShares) {
        <div class="loading-row"><mat-spinner diameter="18"></mat-spinner><span>Loading…</span></div>
      }
      @for (c of visibleShares; track c.internalContactsID) {
        <div class="collab-row">
          <span class="initials-avatar">{{ initials(c.name) }}</span>
          <div class="collab-id">
            <div class="collab-name">{{ c.name }}</div>
            <div class="collab-email">{{ c.email }}</div>
          </div>
          @if (showRoleSelect) {
            <mat-form-field appearance="outline" class="role-select">
              <mat-select [(ngModel)]="c.accessLevel" [disabled]="!canManage">
                <mat-option value="Viewer">Viewer</mat-option>
                <mat-option value="Editor">Editor</mat-option>
              </mat-select>
            </mat-form-field>
          }
          @if (canManage) {
            <button mat-icon-button class="remove-btn" matTooltip="Remove" (click)="removeShare(c)">
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>
      } @empty {
        @if (!loadingShares) {
          <div class="empty-row">{{ shareEmptyText }}</div>
        }
      }
      @if (canManage) {
        <div class="add-people-row">
          <mat-form-field appearance="outline" class="add-people-field">
            <mat-label>{{ sharePickerLabel }}</mat-label>
            <input matInput [(ngModel)]="addQuery" (ngModelChange)="filterUsers()"
                   [matAutocomplete]="collabAuto" autocomplete="off">
            <mat-autocomplete #collabAuto="matAutocomplete" class="user-picker-panel" [displayWith]="displayNothing"
                              (optionSelected)="pickUser($event.option.value, pickRole)">
              @if (loadingDirectory) {
                <mat-option disabled>Loading people…</mat-option>
              }
              @for (u of filteredUsers; track u.internalContactsID) {
                <mat-option [value]="u">
                  <span class="initials-avatar sm">{{ initials(u.name) }}</span>
                  <span class="opt-name">{{ u.name }}</span>
                  <span class="opt-email">{{ u.email }}</span>
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
          @if (showRoleSelect) {
            <mat-form-field appearance="outline" class="role-select">
              <mat-select [(ngModel)]="addRole">
                <mat-option value="Viewer">Viewer</mat-option>
                <mat-option value="Editor">Editor</mat-option>
              </mat-select>
            </mat-form-field>
          }
        </div>
      }
    </div>
  }

</div>

<mat-dialog-actions class="settings-actions">
  <div class="actions-left">
    @if (canDelete) {
      <button mat-button class="delete-text-btn" (click)="deleteView()">Delete</button>
    }
  </div>
  <div class="actions-right">
    <button mat-button (click)="cancel()">Cancel</button>
    @if (canEdit) {
      <button mat-raised-button color="primary" [disabled]="saving || !name.trim()" (click)="save()">
        {{ saveLabel }}
      </button>
    }
  </div>
</mat-dialog-actions>
